import { useEffect } from 'react';
import { useAuthContext } from '../hooks/useAuthContext';
import { usePaymentsContext } from '../hooks/usePaymentsContext';
import { isPaymentAdmin } from '../utils/admins';

// Components
import PaymentDetails from '../components/PaymentDetails';

const Home = () => {
	const { payments, dispatch } = usePaymentsContext();
	const { user } = useAuthContext();

	useEffect(() => {
		const fetchPayments = async () => {
			let response;
			if (isPaymentAdmin(user.email)) {
				response = await fetch('/api/payments/admin', {
					headers: {
						Authorization: `Bearer ${user.token}`,
					},
				});
			} else {
				response = await fetch('/api/payments', {
					headers: {
						Authorization: `Bearer ${user.token}`,
					},
				});
			}
			const json = await response.json();

			if (response.ok) {
				dispatch({ type: 'SET_PAYMENTS', payload: json });
			}
		};

		if (user) {
			fetchPayments();
		}
		//experimental
	}, [dispatch, user]);

	return (
		<div className="home">
			<div className="payments">
				{payments &&
					payments.map((payment) => (
						<PaymentDetails key={payment._id} payment={payment} />
					))}
			</div>
		</div>
	);
};

export default Home;
